import * as React from 'react';
import { AreaInput } from '../../../schema';
import { TSInput } from '../../common/TSInput';
import { Row, Col } from 'antd';
import { Label } from '../../common/TSLabel';
import { DistrictDropdown } from '../District/DistrictDropdown';

export const AreaForm: React.FunctionComponent<Props> = (props) => {
  return (
    <div>
      <Row>
        <Col span={12}>
          <TSInput
            error=""
            value={props.area.name}
            type="text"
            name="name"
            onChange={props.onChange}
            addonBefore="Name"
          />
        </Col>
        <Col span={12}>
          <Label title="District">
            <DistrictDropdown
              onSelect={(e, f) => {
                props.onChange({
                  target: { name: 'districtId', value: String(e) },
                });
              }}
              value={props.area.districtId}
              allowClear
            />
          </Label>
        </Col>
      </Row>
    </div>
  );
};

interface Props {
  area: AreaInput;
  onChange: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string | number | boolean | null } },
  ) => void;
}
